import React, { FC, memo, useMemo } from 'react';
import { useSubscription } from 'use-subscription';
import { EmbedService } from './embedService';

interface EditorEmbedsProps {
  embedService: EmbedService;
}

export const EditorEmbeds: FC<EditorEmbedsProps> = memo(props => {
  const { embedService } = props;
  const embeds = useSubscription(
    useMemo(
      () => ({
        getCurrentValue: () => embedService.renderEmbeds(),
        subscribe: callback => {
          const subscription = embedService.changes$.subscribe(callback);
          return () => subscription.unsubscribe();
        },
      }),
      [embedService],
    ),
  );

  return <>{embeds}</>;
});
